import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createLead = (data) => axios.post(`${API}/leads`, data).then((r) => r.data);
export const careersApply = (formData) => axios.post(`${API}/careers/apply`, formData).then((r) => r.data);
export const subscribe = (email) => axios.post(`${API}/newsletter`, { email }).then((r) => r.data);

// ---- Admin ----
const TOKEN_KEY = "vyft_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/auth/me`, authHeaders()).then((r) => r.data);
export const adminLeads = () => axios.get(`${API}/leads`, authHeaders()).then((r) => r.data);
export const adminSubscribers = () => axios.get(`${API}/subscribers`, authHeaders()).then((r) => r.data);
export const adminStats = () => axios.get(`${API}/stats`, authHeaders()).then((r) => r.data);
export const adminUpdateLead = (id, status) =>
  axios.patch(`${API}/leads/${id}`, { status }, authHeaders()).then((r) => r.data);
export const adminUpdateNotes = (id, notes) =>
  axios.patch(`${API}/leads/${id}/notes`, { notes }, authHeaders()).then((r) => r.data);
export const adminDeleteLead = (id) => axios.delete(`${API}/leads/${id}`, authHeaders()).then((r) => r.data);
export const adminChangePassword = (current_password, new_password) =>
  axios.post(`${API}/auth/change-password`, { current_password, new_password }, authHeaders()).then((r) => r.data);
export const adminDownloadResume = async (id, filename) => {
  const res = await axios.get(`${API}/leads/${id}/resume`, { ...authHeaders(), responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "resume";
  a.click();
  URL.revokeObjectURL(url);
};

// ---- Careers ----
export const publicCareers = () => axios.get(`${API}/careers`).then((r) => r.data);
export const adminListCareers = () => axios.get(`${API}/admin/careers`, authHeaders()).then((r) => r.data);
export const adminCreateCareer = (data) => axios.post(`${API}/admin/careers`, data, authHeaders()).then((r) => r.data);
export const adminUpdateCareer = (id, data) => axios.put(`${API}/admin/careers/${id}`, data, authHeaders()).then((r) => r.data);
export const adminToggleCareer = (id) => axios.patch(`${API}/admin/careers/${id}/toggle`, {}, authHeaders()).then((r) => r.data);
export const adminDeleteCareer = (id) => axios.delete(`${API}/admin/careers/${id}`, authHeaders()).then((r) => r.data);

// ---- Site Content ----
export const publicContent = () => axios.get(`${API}/content`).then((r) => r.data);
export const adminUpdateContent = (data) => axios.put(`${API}/admin/content`, data, authHeaders()).then((r) => r.data);
export const adminResetContent = () => axios.post(`${API}/admin/content/reset`, {}, authHeaders()).then((r) => r.data);
